<template>
  <div :id="id" :class="wrapperClasses">
    <div class="container mx-auto flex max-w-screen-xl flex-col">
      <VcTypography tag="h2" class="normal-case">
        {{ titleFaq }}
      </VcTypography>
      <div v-if="textFaq" class="mb-4" v-html="textFaq"></div>
      <div class="faq-items">
        <template v-for="(item, index) in faqItems" :key="index">
          <div class="mb-2.5 rounded border-2 border-[#EDEDED] p-4 drop-shadow-[1px_2px_4px_rgba(0,0,0,0.05)]">
            <div class="flex cursor-pointer items-center justify-between font-bold" @click="toggleAccordion(index)">
              {{ item.label }}
              <VcIcon
                class="ml-1 text-[--color-primary]"
                :name="isOpen.includes(index) ? 'chevron-up' : 'chevron-down'"
                size="xs"
              />
            </div>
            <transition name="slide-fade-top">
              <div v-if="isOpen.includes(index)" class="pt-4">
                <div v-html="item.text"></div>
              </div>
            </transition>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

type FaqItemsType = {
  label: string;
  text: string;
};

interface IProps {
  id: string;
  background?: string;
  textColor?: string;
  bottomMargin?: string;
  verticalPadding?: string;
  titleFaq?: string;
  textFaq?: string;
  faqItems?: Array<FaqItemsType>;
}

const props = defineProps<IProps>();

const wrapperClasses = computed(() => {
  return [
    props.background ? props.background : "",
    props.textColor ? props.textColor : "text-[color:var(--color-body-text)]",
    props.bottomMargin ? props.bottomMargin : "my-0",
    props.verticalPadding ? props.verticalPadding : "py-10 lg:py-20",
  ];
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isOpen: any = ref([]);

function toggleAccordion(index: number) {
  if (isOpen.value.includes(index)) {
    isOpen.value = isOpen.value.filter((i: number) => i !== index);
    return;
  }

  isOpen.value.push(index);
}
</script>
